<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol sm="4" style="padding-right: 4px">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawaiSearch()"
                            @blur="toggleCloseVisiblePegawaiSearch()"
                            v-model="queryPegawaiSearch"
                            v-text="selectedItemPegawaiSearch ? selectedItemPegawaiSearch['text'] : ''"
                            @keydown.up="upPegawaiSearch"
                            @keydown.down="downPegawaiSearch"
                            @keydown.enter="selectItemPegawaiSearch"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawaiSearch">
                        <div class="options" v-if="matchesPegawaiSearch.length != 0 && queryPegawaiSearch.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawaiSearch"
                                :key="index"
                                :class="{ 'selected': (selectedPegawaiSearch == index)}"
                                @click="itemClickedPegawaiSearch(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawaiSearch.length == 0 && queryPegawaiSearch.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawaiSearch.length == 0 && queryPegawaiSearch.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="3" style="padding-right: 4px;padding-left:4px">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchTipe" class="form-control" v-model="selectedSearchTipe" placeholder="Tipe Keluarga"></model-select>
            </CCol>
            <CCol sm="3" style="padding-right: 4px;padding-left:4px">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchStatus" class="form-control" v-model="selectedSearchStatus" placeholder="Status"></model-select>
            </CCol>
            <CCol sm="2" style="padding-left: 4px">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../../../component/tableKeluarga'
import {DataApi} from "../../../service/DataApi"
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            // data search select pegawai search
            dataPegawaiSearch: [],
            titlePegawaiSearch:"Pilih Pegawai",
            selectedItemPegawaiSearch: null,
            selectedPegawaiSearch: 0,
            queryPegawaiSearch: '',
            visiblePegawaiSearch: false,
            idPegawaiSearch: '',

            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Pegawai', 'Tipe', 'Nama', 'Tanggal Lahir', 'Tanggal Menikah', 'Status'],
            dataTd: ['namaPegawai', 'familyType', 'nama', 'birthDate', 'marriedDate', 'status'],
            styleTable: ['100px', '100px', '100px', '100px', '100px', '100px'],
            classReload: 'reloadOff',
            datas: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            dataSearchStatus: [],
            dataSearchTipe: [],
            selectedSearchTipe: {
                text: '',
                value: ''               
            },
            selectedSearchStatus: {
                text: '',
                value: ''
            },

            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawaiSearch() {
            this.flagSearch = true
            this.getDataPegawaiSearch()
        },
        selectedSearchStatus() {
            this.flagSearch = true
        },
        selectedSearchTipe() {
            this.flagSearch = true
        }
    },
    computed: {
        matchesPegawaiSearch() {
            if (this.queryPegawaiSearch == '') {
                return [];
            }
            return this.dataPegawaiSearch.filter((item) => item['text'].toLowerCase().includes(this.queryPegawaiSearch.toLowerCase()))
        }
    },
    methods: {
        /**
         * SEARCH SELECT PEGAWAI SEARCH
         */
        getDataPegawaiSearch() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawaiSearch,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawaiSearch = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawaiSearch.push(onPush)
                }
            })
        },
        toggleVisiblePegawaiSearch() {
            this.visiblePegawaiSearch = true;
        },
        hidePegawaiSearch() {
            this.visiblePegawaiSearch = false;
        },
        toggleCloseVisiblePegawaiSearch() {
            setTimeout(this.hidePegawaiSearch, 1000);
        },
        itemClickedPegawaiSearch(index) {
            this.selectedPegawaiSearch = index;
            this.selectItemPegawaiSearch();
        },
        selectItemPegawaiSearch() {
            if (!this.matchesPegawaiSearch.length) {
            return;
            }
            this.selectedItemPegawaiSearch = this.matchesPegawaiSearch[this.selectedPegawaiSearch];
            this.visiblePegawaiSearch = false;
            this.queryPegawaiSearch = this.selectedItemPegawaiSearch.text
            this.idPegawaiSearch = this.selectedItemPegawaiSearch.value
            if (this.shouldReset) {
            this.queryPegawaiSearch = '';
            this.selectedPegawaiSearch = 0;
            }
        },
        upPegawaiSearch() {
            if (this.selectedPegawaiSearch == 0) {
            return;
            }
            this.selectedPegawaiSearch -= 1;
            this.scrollToItemPegawaiSearch();
        },
        downPegawaiSearch() {
            if (this.selectedPegawaiSearch >= this.matchesPegawaiSearch.length - 1) {
            return;
            }
            this.selectedPegawaiSearch += 1;
            this.scrollToItemPegawaiSearch();
        },
        scrollToItemPegawaiSearch() {
            this.$refs.optionsList.scrollTop = this.selectedPegawaiSearch * this.itemHeight;
        },

        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaPegawai.toLowerCase() < b.namaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.namaPegawai.toLowerCase() > b.namaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.familyType.toLowerCase() < b.familyType.toLowerCase()) {
                        return -1
                    }
                    if (a.familyType.toLowerCase() > b.familyType.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.birthDate.toLowerCase() < b.birthDate.toLowerCase()) {
                        return -1
                    }
                    if (a.birthDate.toLowerCase() > b.birthDate.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.marriedDate.toLowerCase() < b.marriedDate.toLowerCase()) {
                        return -1
                    }
                    if (a.marriedDate.toLowerCase() > b.marriedDate.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.status.toLowerCase() < b.status.toLowerCase()) {
                        return -1
                    }
                    if (a.status.toLowerCase() > b.status.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let nama = this.queryPegawaiSearch.split(" - ")[0]
            let page = this.page
            let tipe = this.selectedSearchTipe.value
            let status = this.selectedSearchStatus.value

            let payload = {
                limit: limit,
                nama: nama,
                pageIn: page,
                tipe: tipe,
                status: status
            }
            DataApi.post("pegawai/get/family", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawaiSearch = ''
            this.idPegawaiSearch = ''
            this.selectedSearchTipe.value = ''
            this.selectedSearchStatus.value = ''
            this.selectedSearchTipe.text = ''
            this.selectedSearchStatus.text = ''
            this.flagSearch = true
            this.getDataSearchTipe()
            this.getDataSearchStatus()
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        getDataSearchTipe() {
            this.dataSearchTipe = [
                { text: 'Semua', value: '' },
                { text: 'Pasangan', value: 'S'},
                { text: 'Anak', value: 'K'},
                { text: 'Prinsipal', value: 'P'}
            ]
        },
        getDataSearchStatus() {
            this.dataSearchStatus = [
                { text: 'Semua', value: '' },
                { text: 'Active', value: 'A'},
                { text: 'Reject', value: 'R'},                
                { text: 'Delete', value: 'D'},
                { text: 'Pending', value: 'P'}
            ]
        },
    },
    mounted() {
        this.getDataPegawaiSearch()
        this.getDataSearchTipe()
        this.getDataSearchStatus()
        this.errorMessage = 'Find Your Data'
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>